import { getWorkspaceRoot } from '@/infrastructure/storage/workspace-fs/root'

export interface AssistantRuntimeCapabilities {
  hasWorker: boolean
  hasWebCodecs: boolean
  hasAudioEncoder: boolean
  hasVideoEncoder: boolean
  hasAudioDecoder: boolean
  hasOffscreenCanvas: boolean
  hasFileSystemAccess: boolean
  hasSharedArrayBuffer: boolean
  hasWorkspaceRoot: boolean
  canImportLocalMedia: boolean
  canPersistProjectData: boolean
  supportsCloudTts: boolean
  supportedTtsEngines: string[]
  supportsCloudMusicGen: boolean
  supportsCloudTranscription: boolean
  supportsLocalExport: boolean
  supportsProgressEvents: boolean
  supportsCancellation: boolean
}

export function getRuntimeCapabilities(): AssistantRuntimeCapabilities {
  const hasWorker = typeof Worker !== 'undefined'
  const hasAudioEncoder = typeof AudioEncoder !== 'undefined'
  const hasVideoEncoder = typeof VideoEncoder !== 'undefined'
  const hasAudioDecoder = typeof AudioDecoder !== 'undefined'
  const hasOffscreenCanvas = typeof OffscreenCanvas !== 'undefined'
  const hasFileSystemAccess = typeof window !== 'undefined' && 'showOpenFilePicker' in window
  const hasSharedArrayBuffer = typeof SharedArrayBuffer !== 'undefined'
  const hasWorkspaceRoot = !!getWorkspaceRoot()
  const supportedTtsEngines = ['aliyun']

  return {
    hasWorker,
    hasWebCodecs: hasVideoEncoder || hasAudioEncoder || hasAudioDecoder,
    hasAudioEncoder,
    hasVideoEncoder,
    hasAudioDecoder,
    hasOffscreenCanvas,
    hasFileSystemAccess,
    hasSharedArrayBuffer,
    hasWorkspaceRoot,
    canImportLocalMedia: hasFileSystemAccess,
    canPersistProjectData: hasWorkspaceRoot,
    supportsCloudTts: true,
    supportedTtsEngines,
    supportsCloudMusicGen: true,
    supportsCloudTranscription: true,
    supportsLocalExport: hasWorker && hasOffscreenCanvas && (hasVideoEncoder || hasAudioEncoder),
    supportsProgressEvents: true,
    supportsCancellation: true,
  }
}
